enum DraftViewerRole {
  Admin = 'admin',
  TechWriter = 'tech writer',
  Author = 'author',
  Reviewer = 'reviewer',
  Publisher = 'Publisher',
}

export default DraftViewerRole;
